import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IBookingDetailsActionParams, IMonthFilterActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/UpcomingPastBookingActionParams";

class UpcomingPastBookingDetailsAction extends BaseAction<string, IBookingDetailsActionParams> {

    override async run(): Promise<string> {
        const { isPast, bookingId, tripStatus, repeatBooking, direction, tripData } = this.params!

        try {
            if (isPast) {
                updateRecoilState("isPastBookingDetailsAtom", true);
            }
            updateRecoilState("repeatedBookingAtom", {
                tripStatus: tripStatus,
                repeatBooking: repeatBooking,
                direction: direction
            })
            updateRecoilState("displayPassengerDataAtom", tripData.passengers);
            updateRecoilState("selectedTripsDataAtom", tripData);            
            updateRecoilState("defaultActiveKeyForTripSummaryAtom", [])
            updateRecoilState("upgradeOutboundOffersAtom", null);
            updateRecoilState("upgradeInboundOffersAtom", null);
        } catch (error: any) {
            console.error("Error fetching data:", error);
        } finally {
            return bookingId
        }
    }
}

export const upcomingPastBookingDetailsAction = new UpcomingPastBookingDetailsAction()